import { Link, useNavigate, useParams } from 'react-router-dom';
import { getDripEmailReport } from '../../../../../common/api/dripEmails';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Container, Header } from '@cloudscape-design/components';
import { ViewLayout } from '../../../../../components/ViewLayout';
import { LoadingOrError } from '../../../../../components/Loading';

export default function DripEmailReportPage() {
  const { uuid } = useParams();
  const navigate = useNavigate();

  const query = useQuery({
    queryKey: ['drip', 'emails', uuid, 'report'],
    queryFn: () => getDripEmailReport(uuid ?? ''),
  });

  useEffect(() => {
    if (query.data) {
      navigate(`/${query.data.uuid}`);
    }
  }, [query.data]);

  return (
    <ViewLayout
      breadcrumbs={[{ text: 'Reports', href: '/' }]}
      header={<Header variant="h1">Loading...</Header>}
      contentType="dashboard"
      navigationHide
    >
      <Container>
        <LoadingOrError
          loading={query.isLoading}
          error={query.error}
          retry={() => query.refetch()}
        />
      </Container>
    </ViewLayout>
  );
}
